<h1 mat-dialog-title>

    <b>Validar Pago Cuota Convenio</b></h1>
<br/>
<form #validarForm=ngForm>

    <dialog-content>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Solicitante </mat-label>

                <mat-option>{{data.rutUsuario}} {{data.nombreUsuario}} {{data.apellidoUsuario}}</mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Cuota a pagar </mat-label>
                <mat-option> {{data.numCuota}} </mat-option>

            </form-field>
        </p>

        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Monto Cuota </mat-label>
                <mat-option> {{data.montoCuota}} </mat-option>

            </form-field>
        </p>
       
        <p>
            <mat-form-field appearance = "outline" class = "mat-input">             
                <mat-label> Fecha Pago </mat-label>    
                <input  name = "fechaAbono" matInput type = "date" placeholder = "Fecha Pago" [(ngModel)] = "data.fechaAbono"
                 required #fechaAbono = "ngModel">    
            </mat-form-field>
        </p>


        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Descargar Comprobante Pago</mat-label>
                <div class="col-lg-6">
                    <button class="btn-info mat-raised-button" (click)="onDescargarArchivosClick(data.idPlanPago)">

                        <i class = "fa fa-download"> </i> Descargar Archivos Ingresado </button>
                </div>

            </form-field>

        </p>
    </dialog-content>
</form>
<br/>
<mat-dialog-actions>
    <div>
        <button mat-button class="mat-raised-button btn-success" *ngIf="data.mostrarEditar == true" (click)="onAprobarPagoClick(validarForm)">
            <i class ="fa fa-check"> </i> Aceptar
        </button>

        <button mat-button class="mat-raised-button btn-danger" *ngIf="data.mostrarEditar == true" (click)="onRechazarPagoClick(validarForm)">
            <i class = "fa fa-trash"> </i> Rechazar
        </button>

        <button mat-button class="mat-raised-button btn-secondary" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
</mat-dialog-actions>

<br/>